// hooks/useDocketActions.js
export const useDocketActions = (generatePdf) => {
  const handlePrint = async (record) => {
    await generatePdf(`bordereau-edition/${record.id}`, null, 'GET');
  };

  return { handlePrint };
};
